import { FaArrowRight, FaEnvelope, FaMobile, FaPhone, FaPrint } from 'react-icons/fa6'

export function LinkIndicatorIcon() {
  return <FaArrowRight className="text-neutral-400!" />
}

export {
  FaCheck as CheckIcon,
  FaChevronLeft as PreviousStepIcon,
  FaChevronRight as NextStepIcon,
  FaEdit as EditIcon,
  FaFilter as FilterIcon,
  FaSave as SaveIcon,
  FaUndo as ResetIcon,
} from 'react-icons/fa'
export {
  FaList as IndexIndicatorIcon,
  FaPlus as AddIcon,
  FaXmark as CancelIcon,
  FaXmark as StopEditingIcon,
} from 'react-icons/fa6'

// biome-ignore lint/style/useComponentExportOnlyModules: Exporting an object containing icon components for convenience
export const ContactIcons = {
  phone: FaPhone,
  mobile: FaMobile,
  email: FaEnvelope,
  fax: FaPrint,
}
